import { render, staticRenderFns } from "./anchorManage.vue?vue&type=template&id=7e78dabe&scoped=true"
import script from "./anchorManage.vue?vue&type=script&lang=js"
export * from "./anchorManage.vue?vue&type=script&lang=js"
import style0 from "./anchorManage.vue?vue&type=style&index=0&id=7e78dabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e78dabe",
  null
  
)

export default component.exports